import { Col } from 'react-styled-flexboxgrid';
import styled, { css } from 'styled-components';

import { media } from '@savgroup-front-common/constants';

import { getBorderRadius } from './MultiFileUploadHookForm.helpers';

interface IconContainerProps {
  $isDragActive: boolean;
}

interface DropzoneProps {
  $isDragActive: boolean;
}

export const $FileInput = styled.input`
  display: none;
`;

const iconContainerHoverMixin = css<DropzoneProps>`
  > svg {
    opacity: 1;
    transform: translate(-50%, -50%) scale3d(1, 1, 1);
  }
`;

export const $IconContainer = styled.div<IconContainerProps>`
  position: relative;
  > svg {
    width: 4rem;
    height: 4rem;
    position: absolute;
    opacity: 0;

    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%) scale3d(0.8, 0.8, 0.8);
    pointer-events: none;
    transition-duration: 0.3s;
  }
  ${({ $isDragActive }) => ($isDragActive ? iconContainerHoverMixin : null)};
  &:hover {
    ${iconContainerHoverMixin}
  }
`;

const dropZoneHoverMixin = css<DropzoneProps>`
  border-color: ${({ theme }) => theme.colors.primary};
  p {
    filter: blur(2px);
  }
`;

export const $Dropzone = styled.button<DropzoneProps>`
  border: 1px solid ${({ theme }) => theme.colors.default};

  height: 10rem;
  margin: auto;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  background-color: ${({ theme }) => theme.systemColors.secondaryBackground};
  border-radius: ${getBorderRadius};

  transition-duration: 0.3s;

  p {
    font-size: ${({ theme }) => theme.fonts.size.small};
    transition-duration: 0.3s;
  }

  ${({ $isDragActive }) => ($isDragActive ? dropZoneHoverMixin : null)};
  &:hover {
    ${dropZoneHoverMixin};
  }
`;

export const $Col = styled(Col)<{ $dropzone?: boolean }>`
  && {
    flex: ${({ $dropzone }) => ($dropzone ? null : 0)};
    margin-bottom: 1rem;
  }
`;

export const $DropzoneWithCustomChildren = styled.button<DropzoneProps>`
  border: 1px solid ${({ theme }) => theme.colors.default};

  height: 100%;
  margin: auto;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  background-color: ${({ theme }) => theme.systemColors.secondaryBackground};
  border-radius: ${getBorderRadius};

  transition-duration: 0.3s;

  p {
    font-size: ${({ theme }) => theme.fonts.size.small};
    transition-duration: 0.3s;
  }

  ${({ $isDragActive }) => ($isDragActive ? dropZoneHoverMixin : null)};
  &:hover {
    ${dropZoneHoverMixin};
  }

  @media ${media.maxWidth.sm} {
    padding: 0.75rem 0;
    margin: 0;
  }
`;
